import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SaveIcon from '@mui/icons-material/Save';
import {Button, Stack, styled} from '@mui/material';
import {blue} from '@mui/material/colors';
import {FC} from 'react';
import {contractTableFiltersAddModalOpen} from '../../stores/contract-table-filters-add-modal.store';
import {resetFilters, useContractsTableFiltersStore} from '../../stores/contracts-table-filters.store';

export const ContractsTableFiltersActions: FC = () => {
  const filters = useContractsTableFiltersStore((s) => s.filters);
  const disabled = !filters.length;
  const color = disabled ? 'disabled' : 'primary';

  return (
    <Stack direction="row" spacing={4}>
      <StyledButton disabled={disabled} endIcon={<SaveIcon color={color} />} onClick={contractTableFiltersAddModalOpen}>
        Сохранить набор
      </StyledButton>
      <StyledButton disabled={disabled} endIcon={<HighlightOffIcon color={color} />} onClick={resetFilters}>
        Сбросить все
      </StyledButton>
    </Stack>
  );
};

const StyledButton = styled(Button)({
  fontSize: '14px',
  textTransform: 'none',
  borderRadius: 4,
  height: 28,
  backgroundColor: blue[50],
  color: '#000',
  border: `1px solid ${blue[100]}`,

  '&:hover': {
    backgroundColor: blue[100],
  },
});
